export default function SettingsIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 14C12.6569 14 14 12.6569 14 11C14 9.34315 12.6569 8 11 8C9.34315 8 8 9.34315 8 11C8 12.6569 9.34315 14 11 14Z"
        stroke="#007D32"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 11.8804V10.1204C1 9.08042 1.85 8.22043 2.9 8.22043C4.71 8.22043 5.45 6.94042 4.54 5.37042C4.02 4.47042 4.33 3.30042 5.24 2.78042L6.97 1.79042C7.76 1.32042 8.78 1.60042 9.25 2.39042L9.36 2.58042C10.26 4.15042 11.74 4.15042 12.65 2.58042L12.76 2.39042C13.23 1.60042 14.25 1.32042 15.04 1.79042L16.77 2.78042C17.68 3.30042 17.99 4.47042 17.47 5.37042C16.56 6.94042 17.3 8.22043 19.11 8.22043C20.15 8.22043 21.01 9.07042 21.01 10.1204V11.8804C21.01 12.9204 20.16 13.7804 19.11 13.7804C17.3 13.7804 16.56 15.0604 17.47 16.6304C17.99 17.5404 17.68 18.7004 16.77 19.2204L15.04 20.2104C14.25 20.6804 13.23 20.4004 12.76 19.6104L12.65 19.4204C11.75 17.8504 10.27 17.8504 9.36 19.4204L9.25 19.6104C8.78 20.4004 7.76 20.6804 6.97 20.2104L5.24 19.2204C4.33 18.7004 4.02 17.5304 4.54 16.6304C5.45 15.0604 4.71 13.7804 2.9 13.7804C1.85 13.7804 1 12.9204 1 11.8804Z"
        stroke="#007D32"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
